import { useEffect } from 'react';

/**
 * ExternalTradeRedirect
 * ─────────────────────
 * Hard redirect handler for any internal /trade or /platform URL.
 * The user mandated that ALL "Trade" navigation across the entire
 * application MUST land on the external trading subdomain
 * (https://trade.varotrades.com). This component replaces any internal
 * trading-platform route so that even direct URL hits, deep links, or
 * legacy bookmarks are forwarded to the external platform in the SAME tab.
 */
const ExternalTradeRedirect = () => {
  useEffect(() => {
    const external = (
      process.env.REACT_APP_TRADING_PLATFORM_URL ||
      process.env.REACT_APP_PLATFORM_URL ||
      ''
    ).trim();
    if (external) {
      // Use replace so the user can't "Back" into this redirect shim.
      window.location.replace(external);
    } else {
      // No external configured — fall back to home so we don't trap the user.
      window.location.replace('/');
    }
  }, []);

  return (
    <div
      data-testid="external-trade-redirect"
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6b7280',
        fontSize: 14,
      }}
    >
      Redirecting to the trading platform…
    </div>
  );
};

export default ExternalTradeRedirect;
